module.exports = __webpack_public_path__ + "img/airship-hangar.5a8f8a6c.webp";